import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslatesService } from '@shared/translates';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedModalComponent } from 'app/components/shared-modal/shared-modal.component';
import { CategoryService } from '@shared/services/category.service';
import { BlogImage, BlogService } from './blog.service';
import { Article } from './blog.type';
import { faArrowCircleRight } from '@fortawesome/pro-regular-svg-icons';
import { SEOService } from '@shared/services/seo.service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss'],
})
export class BlogComponent implements OnInit {
  title: string;
  isSmall = true;
  page = 1;
  pageSize = 10;
  totalSize = 0;
  articles: Article[];
  subCategoryId: number;
  slug: string;
  image: BlogImage;
  faArrowCircleRight = faArrowCircleRight;

  constructor(
    private readonly blogService: BlogService,
    private readonly seoService: SEOService,
    private route: Router,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private _translatesService: TranslatesService,
    private modalService: NgbModal,
    private categoryService: CategoryService,
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.slug = params.name;
      if (params.number) {
        this.page = params.number;
      }
    });

    this.route.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };

    this.route.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.route.navigated = false;
        // if you need to scroll back to top, here is the right place
        document.body.scrollTop = 0;
      }
    });
  }

  async ngOnInit(): Promise<void> {
    try {
      if (this.slug) {
        const subCategory = await this.categoryService.getSubcategoryBySlug(this.slug);
        this.title = subCategory.name;
        this.subCategoryId = subCategory.id;
      }
      this.image = await this.blogService.getImageBlogBySubCategoryId(
        this.subCategoryId,
      );
      const result = await this.blogService.queryArticle(
        this.page,
        this.pageSize,
        this.subCategoryId,
      );
      this.articles = result.nodes;
      this.totalSize = result.totalCount;
    } catch (err) {
      this.route.navigate(['/404']);
    }
    this.seoService.updateDescription('blog');
  }

  async getCurrentPage(event) {
    try {
      document.body.scrollTop = 0;
      const result = await this.blogService.queryArticle(
        event,
        this.pageSize,
        this.subCategoryId,
      );
      this.articles = result.nodes;
      this.totalSize = result.totalCount;
      if (this.slug) {
        this.location.go(this._translatesService.getCurrentLang() + '/blog/' + this.slug + '/pages/' + this.page);
      } else {
        this.location.go(this._translatesService.getCurrentLang() + '/blog/pages/' + this.page);
      }
    } catch (err) {
      this.route.navigate(['/404']);
    }
  }

  goToArticle(article: Article) {
    const route = '/' + this._translatesService.getCurrentLang() + '/article';
    this.route.navigate([route, article.slugId, article.slug]);
  }

  public async showShareModal(article: Article) {
    const modalRef = this.modalService.open(SharedModalComponent, {
      size: 'lg',
      scrollable: true,
      windowClass: 'blog-share'
    });
    const lang = this._translatesService.getCurrentLang();
    const urls = window.location.href.split(`/${lang}/`);
    const url = `${urls[0]}/${lang}/article/${article.slugId}/${article.slug}`;
    modalRef.componentInstance.url = url;
    modalRef.componentInstance.browserTitle = article.browserTitle;
    modalRef.componentInstance.metaDescription = article.metaDescription;
    modalRef.componentInstance.thumbnail = article.thumbnail;
    modalRef.componentInstance.type = 'blog';
  }
}
